import React, { useEffect, useState, memo } from 'react';
import { useForm } from 'react-hook-form';
import { Save } from 'lucide-react';
import { contentAPI } from '../services/api';
import LoadingSpinner from '../components/LoadingSpinner';
import toast from 'react-hot-toast';

const Pengumuman = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [pengumumanData, setPengumumanData] = useState(null);

  const { register, handleSubmit, setValue, formState: { errors }, reset } = useForm({
    defaultValues: {
      judul: '',
      deskripsi: '',
      list: ''
    }
  });

  useEffect(() => {
    fetchPengumumanData();
  }, []);

  const fetchPengumumanData = async () => {
    try {
      const response = await contentAPI.getPengumuman();
      const data = response?.data?.pengumuman;
      setPengumumanData(data);
      reset(data);
    } catch (error) {
      console.error('Error fetching pengumuman data:', error);
      toast.error('Gagal memuat data pengumuman');
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = async (data) => {
    setSaving(true);
    try {
      if (pengumumanData?._id) {
        await contentAPI.updatePengumuman(pengumumanData._id, data);
        toast.success('Pengumuman berhasil diperbarui');
      } else {
        await contentAPI.createPengumuman(data);
        toast.success('Pengumuman berhasil dibuat');
      }
      fetchPengumumanData();
    } catch (error) {
      console.error('Error saving pengumuman data:', error);
      toast.error('Gagal menyimpan pengumuman');
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async () => {
    if (window.confirm('Apakah Anda yakin ingin menghapus pengumuman ini?')) {
      try {
        await contentAPI.deletePengumuman(pengumumanData._id);
        setPengumumanData(null);
        reset();
        toast.success('Pengumuman berhasil dihapus');
      } catch (error) {
        console.error('Error deleting pengumuman:', error);
        toast.error('Gagal menghapus pengumuman');
      }
    }
  };

  if (loading) return <LoadingSpinner />;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="header-page">Pengumuman</h1>
          <p className="description-page">Kelola pengumuman organisasi</p>
        </div>
        <button
          onClick={handleSubmit(onSubmit)}
          disabled={saving}
          className="btn btn-primary"
        >
          {saving ? <LoadingSpinner size="sm" /> : <Save className="w-4 h-4 mr-2" />}
          {saving ? 'Saving...' : 'Save Changes'}
        </button>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className="space-y-8">
        <div className="card">
          <div className="card-header ">
            <h3 className="card-title">Informasi Pengumuman</h3>
            <p className="card-description">Judul, deskripsi, dan daftar isi pengumuman</p>
          </div>
          <div className="card-content space-y-4">
            <div>
              <label className="block lg:text-sm text-xs font-medium text-gray-700 mb-2">Judul</label>
              <input
                {...register('judul', { required: 'Judul wajib diisi' })}
                className="input"
                placeholder="Judul pengumuman"
              />
              {errors.judul && <p className="text-red-500 text-sm mt-1">{errors.judul.message}</p>}
            </div>

            <div>
              <label className="block lg:text-sm text-xs font-medium text-gray-700 mb-2">Deskripsi</label>
              <textarea
                {...register('deskripsi', { required: 'Deskripsi wajib diisi' })}
                rows={3}
                className="input"
                placeholder="Deskripsi pengumuman"
              />
              {errors.deskripsi && <p className="text-red-500 text-sm mt-1">{errors.deskripsi.message}</p>}
            </div>

            <div>
              <label className="block lg:text-sm text-xs font-medium text-gray-700 ">Daftar List</label>
              <p className="block text-xs font-medium text-gray-500">note: format harus nama lenglap%kelas;</p>
              <p className="block text-xs font-medium text-gray-500">contoh: hisyam%XII IPS4;</p>
              <p className="block text-xs font-medium text-gray-500 mb-2">format di atas bersifat wajib untuk kemudahan konversi data!</p>

              <textarea
                {...register('list', { required: 'List wajib diisi' })}
                //buat ukuran teaxtarea otomatis mengikuti isi
                className="flex h-80 w-full rounded-md border border-gray-300 bg-transparent lg:px-3 lg:py-2 px-2 py-1 lg:text-sm text-xs ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                placeholder="Daftar isi atau isi pengumuman"
              />
              {errors.list && <p className="text-red-500 text-sm mt-1">{errors.list.message}</p>}
            </div>

            <div className="flex gap-2 mt-4">
              {/* <button type="reset" className="btn btn-secondary" onClick={() => reset(pengumumanData)}>Reset</button> */}
              {/* <button type="button" className="btn btn-danger" onClick={handleDelete}>Hapus</button> */}
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default memo(Pengumuman);